const e=e=>{const o=new TextDecoder;return JSON.parse(o.decode(e))};export{e as convertBufferToJSON};
